import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Delaware = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Delaware Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Comprehensive disclosure form with 200 questions required.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Disclosure of Real Property Condition Report: Required.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            New Construction Property Disclosure Form
          </Text>{' '}
          – This form covers all potential issues and conditions that may affect
          the value of the property. It should be used for newly constructed
          properties.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Standard Property Disclosure Form
          </Text>{' '}
          – The State of Delaware requires all sellers of residential property
          to disclose any material defects known to them when the property is
          put up for sale.
        </Text>
      </View>
    </View>
  );
};

export default Delaware;
